import styled from 'styled-components';

interface showSidebar {
  isOpen: boolean;
}

interface showDropdownMenu {
  isActive: boolean;
}

export const Header = styled.div<showSidebar>`
  width: ${({ isOpen }) =>
    isOpen ? 'calc(100% - 80px)' : 'calc(100% - 260px)'};
  height: 65px;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0px 4px 16px 0px rgb(0 0 0 / 5%);
  left: ${({ isOpen }) => (isOpen ? '80px' : '260px')};
  position: fixed;
  z-index: 2;
  transition: all 0.5s;
  display: flex;
  margin-bottom: 60px;
  padding: 0 30px;
`;

export const Logo = styled.div`
  width: 10%;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-top: 17px;
    height: 24px;
  }

  span {
    font-size: 0.7rem;
    font-weight: bold;
    color: #e71037;
  }
`;

export const Profile = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;

  img {
    height: 40px;
    cursor: pointer;
  }
`;

export const DropdownMenu = styled.div<showDropdownMenu>`
  width: 220px;
  height: auto;
  background: #fff;
  box-shadow: 0px 4px 16px 16px rgb(0 0 0 / 5%);
  border-radius: 8px;
  position: absolute;
  top: 64px;
  right: 21px;
  opacity: ${({ isActive }) => (isActive ? '1' : '0')};
  visibility: visible;
  transform: ${({ isActive }) =>
    isActive ? 'translateX(0)' : 'translateX(300px)'};
  transition: 0.2s ease;
  z-index: 999;

  &::before {
    content: '';
    position: absolute;
    top: -5px;
    right: 18px;
    width: 20px;
    height: 20px;
    background-color: #fff;
    transform: rotate(45deg);
  }
`;

export const DropdownMenuHeader = styled.div`
  width: 100%;
  padding: 16px 24px;
  border-bottom: 1px solid #f1f2f3;

  h3 {
    font-size: 0.9rem;
    font-weight: 700;
    color: #2e3958;
    margin-bottom: 6px;
    line-break: auto;
  }

  p {
    font-size: 0.875rem;
    font-weight: 400;
    color: #677383;
  }
`;

export const ListItem = styled.ul`
  list-style: none;
  padding: 16px 24px;

  li {
    a {
      display: block;
      text-decoration: none;
      font-size: 0.875rem;
      font-weight: 400;
      color: #2e3958;
      display: flex;
      align-items: center;
      padding: 12px 0;
      svg {
        font-size: 1.2rem;
        margin-right: 16px;
      }

      &:hover {
        color: #e4003a;
        cursor: pointer;
      }
    }
  }
`;
